<template>
  <div class="px-2 py-2 container-fluid">
    <!-- CABECERA SELECCION DE FARMACIA -->
    <div id="profile" v-if="$store.state.profile.permisos?.isAdmin==1" class="card card-body m-0">
      <div class="row justify-content-center align-items-center pt-4 pb-4">
        <Form role="form" class="text-start row">
          <label class="text-analiza-dark m-0 p-0 col-12 col-md-2 text-base">Seleccione Farmacia</label>

          <soft-input-autocomplete
              id="input-farmacia"
              class="farmacia col-12 col-md-8 m-0"
              name="input-farmacia"
              v-model="textoFarmacia"
              :fetchData="buscarFarmaciasAutocomplete"
              queryParam="texto"
              label=""
              placeholder="Indique farmacia..."
              icon="fas fa-search" iconDir="left"
              @input="farmaciaSeleccionada = null"
              @selected="guardarFarmaciaSeleccionada"
          />

          <div class="text-center col-12 col-md-2 p-0">
              <soft-button
                  class="text-base p-2 font-weight-bolder text-analiza-dark"
                  color="analiza-medium"
                  type="button"
                  full-width
                  :is-disabled="loading"
                  @click="onFarmaciaSeleccionada(true)">
                  <span v-if="loading" class="spinner-border spinner-border-sm"></span>
                  <span v-else>Cambiar</span>
              </soft-button>
          </div>
        </Form>
      </div>
    </div>

    <!-- FICHA DE FARMACIA -->
    <div v-if="IdFarmacia" id="presentacion" class="card card-body mt-4">
      <div class="row">
        <div class="col-6 justify-content-center align-items-center pt-4 pb-4 text-analiza-dark">
          <p class="text-md mb-0" v-if="farmacia?.Siglas!=''"><span style="display:inline-block;width:100px;font-weight:700;">Farmacia:</span>{{ farmacia?.Siglas }}</p>
          <p class="text-md mb-0" v-if="farmacia?.Siglas!=''"><span style="display:inline-block;width:100px;font-weight:700;">Titular:</span>{{ farmacia?.Titulares }}</p>
          <p class="text-md mb-0" v-if="farmacia?.Siglas!=''"><span style="display:inline-block;width:100px;font-weight:700;">Dirección:</span>{{ farmacia?.Direccion }}</p>
          <p class="text-md mb-0" v-if="farmacia?.Siglas!=''"><span style="display:inline-block;width:100px;font-weight:700;">Población:</span>{{ farmacia?.CodigoPostal }} {{ farmacia?.Concello }}</p>
          <p class="text-md mb-0" v-if="farmacia?.Siglas!=''"><span style="display:inline-block;width:100px;font-weight:700;">Provincia:</span>{{ farmacia?.Provincia }}</p>
          <hr/>
          <p class="text-md mb-0" v-if="farmacia?.Siglas!=''" style="font-weight:700;">Datos fiscales:</p>
          <p class="text-base mb-0"><span style="display:inline-block;width:150px;font-weight:700;">NIF:</span>{{ cliente?.CIF }}</p>
          <p class="text-base mb-0"><span style="display:inline-block;width:150px;font-weight:700;">Razón social:</span>{{ cliente?.Nombre }}</p>
          <p class="text-base mb-0"><span style="display:inline-block;width:150px;font-weight:700;">Email:</span>{{ cliente?.Email }}</p>
          <p class="text-base mb-0"><span style="display:inline-block;width:150px;font-weight:700;">Teléfono:</span>{{ cliente?.Telefono }}</p>
        </div>
        <div class="col-6 justify-content-center align-items-center pt-4 pb-4" v-if="farmacia?.Siglas!=''">
          <div ref="mapa" id="mapa" class="mapa"></div>
        </div>
      </div>
    </div>

    <!-- FILA DE AVISOS -->
    <div v-if="IdFarmacia" id="row-avisos" class="mt-4" style="overflow:hidden;">
      <div class="row">
        <div class="col-8">
            <div class="card">
                <!--<div class="card-header pb-0 p-3">-->
                    <div class="row m-3 mb-0 ">
                        <div class="col-6 d-flex align-items-center p-0">
                            <h6 class="mb-0">Avisos</h6>
                        </div>
                        <div class="col-6 text-end p-0">
                            <soft-button color="dark" size="sm" class="btn btn-analiza-medium py-2 font-weight-bolder px-4 text-dark">VER TODAS</soft-button>
                        </div>
                    </div>
                <!--</div>-->
                <!--<div class="card-body p-3 pb-0 mb-0">-->
                    <ul class="list-group m-3 mb-0">
                        <li class="list-group-item d-flex justify-content-between ps-0 mb-2">
                            <div class="d-flex align-items-center text-sm text-dark" style="width:70px;height:32px;position:relative;margin-top:2px;">
                                <span style="font-size:32px;line-height:32px;">22</span>
                                <span style="position:absolute;right:0;top:0;font-size:12px;">MAR</span>
                                <span style="position:absolute;right:0;bottom:0;font-size:12px;">2026</span>
                            </div>
                            <div class="d-flex flex-column" style="width:calc(100% - 100px);padding-left:12px;">
                                <h6 class="mb-0 text-dark font-weight-bold text-sm">Titulo de mi aviso</h6>
                                <span class="text-xs" style="top:-3px;position:relative;">Este es el detalle de mi aviso</span>
                            </div>
                            <div class="d-flex align-items-center btn btn-icon-only btn-rounded btn-sm d-flex align-items-center justify-content-center btn-outline-success mb-0" style="margin-top:3px;">
                                <i class="fas fa-arrow-up me-1 text-xs" color="success" aria-hidden="true"></i>
                            </div>
                        </li>
                        <li class="list-group-item d-flex justify-content-between ps-0 mb-2">
                            <div class="d-flex align-items-center text-sm text-dark" style="width:70px;height:32px;position:relative;margin-top:2px;">
                                <span style="font-size:32px;line-height:32px;">21</span>
                                <span style="position:absolute;right:0;top:0;font-size:12px;">MAR</span>
                                <span style="position:absolute;right:0;bottom:0;font-size:12px;">2026</span>
                            </div>
                            <div class="d-flex flex-column" style="width:calc(100% - 100px);padding-left:12px;">
                                <h6 class="mb-0 text-dark font-weight-bold text-sm">Titulo de mi aviso222</h6>
                                <span class="text-xs" style="top:-3px;position:relative;">Este es el detalle de mi aviso222</span>
                            </div>
                            <div class="d-flex align-items-center btn btn-icon-only btn-rounded btn-sm d-flex align-items-center justify-content-center btn-outline-success mb-0" style="margin-top:3px;">
                                <i class="fas fa-arrow-up me-1 text-xs" color="success" aria-hidden="true"></i>
                            </div>
                        </li>
                    </ul>
                <!--</div>-->
            </div>
        </div>
        <div class="col-4">
            <div class="card card-body">
                    <p class="text-lg mb-0">XXXXX</p>
            </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import SoftInputAutocomplete from "@/components/SoftInputAutocomplete.vue";
  import SoftButton from "@/components/SoftButton.vue";
  import showSwal from "/src/mixins/showSwal.js";
  import { Form } from "vee-validate";
  import L from "leaflet";
  import "leaflet/dist/leaflet.css";
  import {globalFunctionsMixin} from '@/mixins/globalFunctions.js';

  export default {
    name: "Home",
    components: {
        SoftInputAutocomplete,
        SoftButton,
        Form,
    },
    mixins: [globalFunctionsMixin],
    methods: {
      guardarFarmaciaSeleccionada(farmacia) {
        this.farmaciaSeleccionada = farmacia;
      },
      async onFarmaciaSeleccionada(reiniciar = false) {
        if (!this.farmaciaSeleccionada?.id) {
            showSwal.methods.showSwal({
                type: "error",
                message: "Seleccione una farmacia",
                width: 500,
            });
            return;
        }

        await this.cargarFarmacia(this.farmaciaSeleccionada.id, reiniciar);
      },
      async cargarFarmacia(id, reiniciar = false) {
        try {
            this.loading = true;
            const response = await this.$store.dispatch("auth/seleccionaFarmacia", { id });
            this.cliente = response.cliente;
            this.farmacia = response.farmacia;
            await localStorage.setItem("datosCliente", JSON.stringify(response.cliente));
            await localStorage.setItem("datosFarmacia", JSON.stringify(response.farmacia));
            this.IdFarmacia = response.farmacia?.IdFarmacia ?? response.farmacia?.Id ?? response.farmacia?.id ?? id;
            if (reiniciar) {
              window.location.reload();
            }
            else {
              this.$nextTick(() => this.actualizarMapaFarmacia());
            }
        } 
        catch (error) { 
            showSwal.methods.showSwal({
                type: "error",
                message: "Se ha producido un error",
                width: 500,
            });
        } finally {
            this.loading = false;
        }
      },
      async buscarFarmaciasAutocomplete(params) {
          const searchText = params?.search?.trim();
          if (!searchText) {
              return [];
          }
          try {
              const response = await this.$store.dispatch("auth/autocompletaFarmacia",{ texto: searchText });
              if (Array.isArray(response)) {
                return response;
              }
              return [];
          } 
          catch (error) { 
              showSwal.methods.showSwal({
                  type: "error",
                  message: "Se ha producido un error",
                  width: 500,
              });
              return [];
          }
      },
      async recuperarDatosLocalStorage() {
          this.cliente = await this.leerLocalStorage("datosCliente");
          this.farmacia = await this.leerLocalStorage("datosFarmacia");

          this.IdFarmacia = this.farmacia?.IdFarmacia ?? this.farmacia?.Id ?? this.farmacia?.id ?? '';

          if (this.IdFarmacia) {
              this.$nextTick(() => this.actualizarMapaFarmacia());
              return;
          }

          const userF = await this.leerLocalStorage("userF");
          if (typeof userF !== "string" || !userF.trim()) {
              await this.logoutUser();
              return;
          }

          const farmaciaIdPermisos = this.$store.state.profile.permisos?.farmaciaId;
          if (!farmaciaIdPermisos) {
              return;
          }

          await this.cargarFarmacia(farmaciaIdPermisos);
      },
      initMap() {
          if (this.map || !this.$refs.mapa) {
              return;
          }

          try {
              this.map = L.map(this.$refs.mapa, { zoomControl: true }).setView(this.lalinCoords, 8);
              L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                  attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              }).addTo(this.map);

              try {
                  delete L.Icon.Default.prototype._getIconUrl;
                  L.Icon.Default.mergeOptions({
                      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
                      iconUrl: require("leaflet/dist/images/marker-icon.png"),
                      shadowUrl: require("leaflet/dist/images/marker-shadow.png")
                  });
              } catch (error) {
                  // Leaflet puede resolver los iconos por CSS si webpack no aplica require.
              }

              this.markerLayer = L.featureGroup().addTo(this.map);
          } catch (error) {
              console.error("Error inicializando Leaflet:", error);
          }
      },
      actualizarMapaFarmacia() {
          const lat = parseFloat(this.farmacia?.Latitud);
          const lng = parseFloat(this.farmacia?.Longitud);

          if (Number.isNaN(lat) || Number.isNaN(lng)) {
              return;
          }

          this.initMap();

          if (!this.map || !this.markerLayer) {
              return;
          }

          this.markerLayer.clearLayers();

          const customIcon = L.icon({
              iconUrl: require("@/assets/img/marker-farmacia.png"),
              iconSize: [50, 75],
              iconAnchor: [25, 75],
              popupAnchor: [0, -75]
          });

          L.marker([lat, lng], { icon: customIcon }).addTo(this.markerLayer);
          this.map.setView([lat, lng], 14);
          this.map.invalidateSize();
      },
      async logoutUser() {
        try {
            await this.$store.dispatch("auth/logout");
        } finally {
            localStorage.clear();
            this.$router.push("/login");
        }
      },
    },
    data() {
      return {
          textoFarmacia: '',
          farmaciaSeleccionada: null,
          IdFarmacia: '',
          cliente: {},
          farmacia: {},
          map: null,
          markerLayer: null,
          lalinCoords: [42.726, -8.152],
          loading: false,
      };
    },
    async beforeMount() {
      this.$store.state.showNavbar = true;
      this.$store.state.showSidenav = true;
    },
    beforeRouteEnter(to, from, next) {
      next(vm => vm.recuperarDatosLocalStorage());
    },
    beforeUnmount() {
      if (this.map) {
          this.map.remove();
          this.map = null;
      }
    }
  };
</script>
<style >
  .cabecera { height:58px;max-height:80px;border-bottom-right-radius:0.6rem;border-bottom-left-radius:0.6rem;overflow:hidden;border:0;}
  .cabecera > .left {height:100%;display:flex;align-items:end;float:left;padding-bottom:0.75rem;}
  .cabecera > .left > .navbar-brand {margin:0px 12px!important;display:inline-block;height:100%;padding:5px;}
  .cabecera > .left > p {display:inline-block;font-size:20px;margin:0;line-height:22px;font-weight:600;}
  .cabecera > .right {height:100%;display:flex;align-items:start;float:right;}
  .cabecera > .right > a {width:30px;height:30px;border-radius:100%;text-align:center;font-size:18px;}
  #mapa.mapa {height: 320px;width: 100%;}
  #profile {overflow: visible;transition: padding-bottom 0.2s ease;}
  #profile:has(.autocomplete-list) {padding-bottom: 16rem !important;}
  html {height: 100%;background-color: #f8f9fa;}
  .list-group-item {border:0!important;border-bottom:1px solid var(--bs-gray-300)!important;}
  .list-group-item:last-child {border-bottom:0!important;}
  @media (max-width: 1250px) {
    .cabecera > .left > p {padding-left: 2.5rem!important;}
  }
</style>
